let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kotjW")).then(() => parcelRequire('1JK4e'));